export const iconFontAwesomeMapsAnchor = (
	<i className="fa-solid fa-anchor"></i>
);
